export const session = (axios) => ({
  signIn: (query) => {
    return axios.post('/frontend_user_auths/user_auths/sign_in', query)
  },
  signOut: () => {
    return axios.delete('/frontend_user_auths/user_auths/sign_out')
  },
  signedIn: () => {
    return axios.get('/frontend_user_auths/validate_auths')
  }
})
